import { render, staticRenderFns } from "./Calendarios.vue?vue&type=template&id=19872ed9&"
import script from "./Calendarios.vue?vue&type=script&lang=ts&"
export * from "./Calendarios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports